import { cores, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { CustomSelect, CustomTextField, CustomThemeProvider } from "../../Styles/theme/customThemeprovider";
import HomeViewTecnico from "../../Styles/layout/homeViewTecnico";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import { func_print } from "../../Func_genericas/func_print";
import { ArmazemEntrada, ArmazemSaida, CampoSchema, IArmazem, Icampovariavel, TipoArmazem_array, TipoCampo, TIPOS_CAMPO, TIPOS_MOTIVO } from "../../Interfaces/armazem/armazem";
import { del, get, post, post_file_faturas, put } from "../../Services/tokenConfig";
import { AuthContext } from "../../AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { Button, Modal, Select, Snackbar, Step, StepLabel, Stepper, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import { loader } from "../../Func_genericas/loader";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import Switch from "react-switch";
import { MenuItem } from "@mui/material";
import { Alert } from "../../Components/Alert/Alert";
import { ButtonCadernos } from "../../Components/barra-de-ferramentas/ButtonCadernos";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { ModalValidarDadosFatura } from "./modal_validar_dados_fatura_armazem";
import LoadingVulpes from "../../Styles/Loader/loading";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(2),
    },
    label: {
      display: "flex",
      flexWrap: "wrap",
      "& > *": {
        // margin: theme.spacing(1),
        // width: theme.spacing(16),
        // height: theme.spacing(16),
        // minWidth: 325,
      },
    },
    header: {
      textAlign: "center",
      background: "#FAFAFA",
      color: "#7e2706",
    },
    picker: {
      color: "#7e2706",
      "&.Mui-checked": {
        color: "#ccafa3",
      },
    },
    tabs: {
      "& .MuiTabs-indicator": {
        backgroundColor: cores.cor1,
        height: 3,
      },
      "& .MuiTab-root.Mui-selected": {
        color: cores.cor1,
      },
    },
  })
);
function Armazem() {

  const classes = useStyles();

  const auth = useContext(AuthContext);
  const location = useLocation();

  const [passo_atual, set_passo_atual] = useState<number>(0);

  const steps = [
    'Informações Adicionais',
    'Selecionar Colunas',
  ];

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [lista_de_armazens, set_lista_de_armazens] = useState<IArmazem[]>([])
  const [lista_de_entradas, set_lista_de_entradas] = useState<ArmazemEntrada[]>([])
  const [lista_de_saidas, set_lista_de_saidas] = useState<ArmazemSaida[]>([])
  const [lista_de_saidas_e_entradas, set_lista_de_saidas_e_entradas] = useState<(ArmazemSaida | ArmazemEntrada)[]>([])
  const [entrada_ou_saida_to_delete, set_entrada_ou_saida_to_delete] = useState<(ArmazemSaida | ArmazemEntrada)>()

  const [lista_de_campos, set_lista_de_campos] = useState<CampoSchema[]>([])
  // const [lista_de_campos_selecionados, set_lista_de_campos_selecionados] = useState<CampoSchema[]>([])
  // const [lista_de_campos_adicionados, set_lista_de_campos_adicionados] = useState<CampoSchema[]>([])
  const [novo_armazem, set_novo_armazem] = useState<IArmazem | undefined>()
  const [armazem_to_delete, set_armazem_to_delete] = useState<IArmazem | undefined>()
  const [novo_campo, set_novo_campo] = useState<CampoSchema | undefined>()
  // const [lista_de_armazens_select, set_lista_de_armazens_select] = useState<IArmazem[]>([])
  const [armazem_selecionado, set_armazem_selecionado] = useState<IArmazem>()

  const [open_dialog_tem_a_certeza_que_quer_eliminar_entrada_ou_saida, set_open_dialog_tem_a_certeza_que_quer_eliminar_entrada_ou_saida] = useState<boolean>(false);
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState<boolean>(false);
  const [flag_open_modal_add_tabela, set_flag_open_modal_add_tabela] = useState<boolean>(false);
  const [flag_open_modal_edit_tabela, set_flag_open_modal_edit_tabela] = useState<boolean>(false);
  const [flag_open_modal_add_campo, set_flag_open_modal_add_campo] = useState<boolean>(false);
  const [flag_open_modal_add_entrada, set_flag_open_modal_add_entrada] = useState<boolean>(false);
  const [flag_open_modal_add_saida, set_flag_open_modal_add_saida] = useState<boolean>(false);
  const [flag_open_modal_edit_entrada, set_flag_open_modal_edit_entrada] = useState<boolean>(false);
  const [flag_open_modal_edit_saida, set_flag_open_modal_edit_saida] = useState<boolean>(false);
  const [nova_entrada, set_nova_entrada] = useState<ArmazemEntrada | undefined>()
  const [nova_saida, set_nova_saida] = useState<ArmazemSaida | undefined>()


  const [stock_minimo_default, set_stock_minimo_default] = useState<string>();
  const [flag_controlar_stock, set_flag_controlar_stock] = useState<boolean>(false);
  const [flag_permitir_stock_negativo, set_flag_permitir_stock_negativo] = useState<boolean>(false);
  const [flag_alerta_stock_minimo, set_flag_alerta_stock_minimo] = useState<boolean>(false);
  const [error_stock_minimo_default, set_error_stock_minimo_default] = useState<boolean>(false);
  const [flag_armazem_ativo, set_flag_armazem_ativo] = useState<boolean>(true);

  const [validacao_max, set_validacao_max] = useState<string>();
  const [error_validacao_max, set_error_validacao_max] = useState<boolean>(false);
  const [validacao_min, set_validacao_min] = useState<string>();
  const [error_validacao_min, set_error_validacao_min] = useState<boolean>(false);
  const [flag_campo_obrigatorio, set_flag_campo_obrigatorio] = useState<boolean>(false);
  const [error_valor_padrao, set_error_valor_padrao] = useState<boolean>(false);

  const [openSnackSuccess, setOpenSnackSuccess] = useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const [hover, setHover] = useState({ flag: false, nome: '' });
  const [hover_armazes, setHover_armazes] = useState({ flag: false, id: 0 });

  const [campo_obrigatorio_nome, set_campo_obrigatorio_nome] = useState<boolean>(false);
  const [campo_obrigatorio_nome_campo, set_campo_obrigatorio_nome_campo] = useState<boolean>(false);

  const [error_data_entrada, set_error_data_entrada] = useState<boolean>(false);
  const [error_quantidade_entrada, set_error_quantidade_entrada] = useState<boolean>(false);
  const [error_entrada_registado_por, set_error_entrada_registado_por] = useState<boolean>(false);

  const [error_data_saida, set_error_data_saida] = useState<boolean>(false);
  const [error_quantidade_saida, set_error_quantidade_saida] = useState<boolean>(false);
  const [error_saida_registado_por, set_error_saida_registado_por] = useState<boolean>(false);
  const [error_motivo, set_error_motivo] = useState<boolean>(false);
  const [list_aux_from_faturas, set_list_aux_from_faturas] = useState<ArmazemEntrada[]>([]);
  const [open_modal_confirmar_dados_da_fatura, set_open_modal_confirmar_dados_da_fatura] = useState<boolean>(false);

  const get_info = async () => {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, 'armazens');


      let lista_aux_armazem: any = []

      let lista_aux_campos = res.data.map((el: IArmazem) => {
        if (el.activo && el.id_agri === location.state) {
          lista_aux_armazem.push(el)
        }

        return el.schema_custom.campos

      })
      set_lista_de_armazens(lista_aux_armazem)


      let lista_aux_campos_final: any = Array.from(new Map(lista_aux_campos.flat().map((campo: any) => [campo.nome, campo])).values())
      set_lista_de_campos(lista_aux_campos_final)

      setIsLoading(false);

    } catch (error) {
      func_print("get_info", error, true);
      setIsLoading(false);
    }
  }

  const criar_armazem = async () => {

    if (novo_armazem?.nome === undefined || novo_armazem?.nome === '') {
      set_campo_obrigatorio_nome(true)
    } else {

      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, 'armazens', {
          id_armazem: 0,
          nome: novo_armazem?.nome === undefined ? '' : novo_armazem?.nome,
          descricao: novo_armazem?.descricao === undefined ? '' : novo_armazem?.descricao,
          tipo_armazem: novo_armazem?.tipo_armazem === undefined ? '' : novo_armazem?.tipo_armazem,
          localizacao: novo_armazem?.localizacao === undefined ? '' : novo_armazem?.localizacao,
          schema_custom: novo_armazem?.schema_custom.campos === undefined ? { campos: [] } : { campos: novo_armazem?.schema_custom.campos },
          validacao_config: {
            controlar_stock: flag_controlar_stock,
            permitir_stock_negativo: flag_permitir_stock_negativo,
            alerta_stock_minimo: flag_alerta_stock_minimo,
            stock_minimo_default: stock_minimo_default === undefined ? 0 : Number(stock_minimo_default)
          },
          activo: flag_armazem_ativo === undefined ? true : flag_armazem_ativo,
          create_date: new Date().toISOString(),
          last_update: new Date().toISOString(),
          uuid: '',
          id_agri: location.state,

        });
        if (lista_de_armazens.length === 0) {
          set_lista_de_armazens([res.data])

        } else {
          set_lista_de_armazens((old: any) => [...old, res.data])

        }
        let lista_aux_campos = lista_de_campos.concat(res.data.schema_custom.campos)

        let lista_aux_campos_final: any = Array.from(new Set(lista_aux_campos))
        set_lista_de_campos(lista_aux_campos_final)
        setMessage(operacao_sucesso)
        setOpenSnackSuccess(true);
        setIsLoading(false);
        func_reset_all()

      } catch (error) {
        func_print("criar_armazem", error, true);
        setMessage(operacao_erro)
        setOpenSnackError(true);
        setIsLoading(false);
      }
    }

  }
  const edit_armazem = async () => {
    if (novo_armazem?.nome === undefined || novo_armazem?.nome === '') {
      set_campo_obrigatorio_nome(true)
    } else {
      try {
        setIsLoading(true);
        let res = await put(auth.token.cookie_token, 'armazens/' + novo_armazem?.id_armazem, {
          id_armazem: novo_armazem?.id_armazem === undefined ? 0 : novo_armazem?.id_armazem,
          nome: novo_armazem?.nome === undefined ? '' : novo_armazem?.nome,
          descricao: novo_armazem?.descricao === undefined ? '' : novo_armazem?.descricao,
          tipo_armazem: novo_armazem?.tipo_armazem === undefined ? '' : novo_armazem?.tipo_armazem,
          localizacao: novo_armazem?.localizacao === undefined ? '' : novo_armazem?.localizacao,
          schema_custom: novo_armazem?.schema_custom.campos === undefined ? { campos: [] } : { campos: novo_armazem?.schema_custom.campos },
          validacao_config: {
            controlar_stock: flag_controlar_stock,
            permitir_stock_negativo: flag_permitir_stock_negativo,
            alerta_stock_minimo: flag_alerta_stock_minimo,
            stock_minimo_default: stock_minimo_default === undefined ? 0 : Number(stock_minimo_default)
          },
          activo: flag_armazem_ativo === undefined ? true : flag_armazem_ativo,
          create_date: new Date().toISOString(),
          last_update: new Date().toISOString(),
          uuid: '',
          id_agri: location.state,

        });
        let lista_aux = lista_de_armazens.filter((el) => {
          if (el.id_armazem === res.data.id_armazem) {
            return res.data
          } else {
            return el
          }
        })
        set_lista_de_armazens(lista_aux)

        // let lista_aux_campos = lista_de_campos.concat(res.data.schema_custom.campos)

        // let lista_aux_campos_final: any = Array.from(new Set(lista_aux_campos))
        const lista_aux_campos_final = Array.from(
          new Map(
            [...lista_de_campos, ...res.data.schema_custom.campos].map(obj => [obj.nome, obj])
          ).values()
        )

        set_lista_de_campos(lista_aux_campos_final)
        set_armazem_selecionado(res.data)
        func_reset_all()
        setMessage(operacao_sucesso)
        setOpenSnackSuccess(true);
        setIsLoading(false);

      } catch (error) {
        func_print("edit_armazem", error, true);
        setMessage(operacao_erro)
        setOpenSnackError(true);
        setIsLoading(false);
      }
    }
  }

  const func_reset_all = () => {
    set_flag_open_modal_edit_tabela(false)
    set_flag_open_modal_add_tabela(false)
    set_passo_atual(0)

    set_novo_armazem(undefined)
    set_novo_campo(undefined)
    set_flag_controlar_stock(false)
    set_flag_permitir_stock_negativo(false)
    set_flag_alerta_stock_minimo(false)
    set_stock_minimo_default('')
    set_error_stock_minimo_default(false)
    set_campo_obrigatorio_nome(false)

    set_novo_armazem((old: any) => ({
      ...old,
      'tipo_armazem': 'outros',
    }));
    func_reset_campos()
  }
  const func_reset_campos = () => {
    set_novo_campo(undefined)
    set_error_validacao_max(false)
    set_validacao_max('')
    set_error_validacao_min(false)
    set_validacao_min('')
    set_error_valor_padrao(false)
    set_campo_obrigatorio_nome_campo(false)

  }
  const func_reset_entrada = () => {
    set_flag_open_modal_edit_entrada(false)
    set_nova_entrada(undefined)
    set_error_data_entrada(false)
    set_error_entrada_registado_por(false)
    set_error_quantidade_entrada(false)
    set_flag_open_modal_add_entrada(false)
    set_flag_armazem_ativo(true)

  }

  const func_reset_saida = () => {
    set_flag_open_modal_edit_saida(false)
    set_nova_saida(undefined)
    set_error_data_saida(false)
    set_error_saida_registado_por(false)
    set_error_quantidade_saida(false)
    set_flag_open_modal_add_saida(false)
    set_error_motivo(false)


  }


  const handle_delete_armazem = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `armazens/${armazem_to_delete?.id_armazem}`
      );
      if (res.status === 204) {
        let lista_aux: any = lista_de_armazens?.filter((el) => {
          if (el.id_armazem !== armazem_to_delete?.id_armazem) {
            return el
          }
        })
        set_lista_de_armazens(lista_aux === undefined ? [] : lista_aux)
        set_armazem_to_delete(undefined)
        set_armazem_selecionado(undefined)
        setMessage("Registo eliminado com sucesso!");
        set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_armazem", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  }
  const onInputChange = (event: any) => {
    const { name, value } = event.target;

    if (name === 'stock_minimo_default') {
      if (!/^\d+$/.test(value)) {
        set_error_stock_minimo_default(true)
      } else {
        set_error_stock_minimo_default(false)
      }
      if (value.length === 0) {
        set_error_stock_minimo_default(false)

      }

      set_stock_minimo_default(value)
    } else {
      set_novo_armazem((old: any) => ({
        ...old,
        [name]: value,
      }));
    }

  }
  const onInputChange_campo = (event: any) => {
    const { name, value } = event.target;

    if (name === 'validacao_max') {
      if (!/^\d+$/.test(value)) {
        set_error_validacao_max(true)
      } else {
        set_error_validacao_max(false)
      }
      if (value.length === 0) {
        set_error_validacao_max(false)

      }

      set_validacao_max(value)
    } if (name === 'validacao_min') {
      if (!/^\d+$/.test(value)) {
        set_error_validacao_min(true)
      } else {
        set_error_validacao_min(false)
      }
      if (value.length === 0) {
        set_error_validacao_min(false)

      }
      set_validacao_min(value)
    } if (name === 'valor_padrao') {
      if (!/^\d+$/.test(value)) {
        set_error_valor_padrao(true)
      } else {
        set_error_valor_padrao(false)
      }
      if (value.length === 0) {
        set_error_valor_padrao(false)

      }
      set_novo_campo((old: any) => ({
        ...old,
        [name]: value,
      }));
    } else {
      set_novo_campo((old: any) => ({
        ...old,
        [name]: value,
      }));
    }

  }
  const onInputChange_entrada = (event: any) => {
    const { name, value } = event.target;

    if (name === 'quantidade_entrada') {
      if (!/^\d+$/.test(value)) {
        set_error_quantidade_entrada(true)
      } else {
        set_error_quantidade_entrada(false)
      }
      set_nova_entrada((old: any) => ({
        ...old,
        [name]: value,
      }));
    }
    else {
      set_nova_entrada((old: any) => ({
        ...old,
        [name]: value,
      }));
    }

  }
  const onInputChange_saida = (event: any) => {
    const { name, value } = event.target;

    if (name === 'quantidade_saida') {
      if (!/^\d+$/.test(value)) {
        set_error_quantidade_saida(true)
      } else {
        set_error_quantidade_saida(false)
      }
      set_nova_saida((old: any) => ({
        ...old,
        [name]: value,
      }));
    }
    else {
      set_nova_saida((old: any) => ({
        ...old,
        [name]: value,
      }));
    }

  }

  const handle_add_campo = () => {

    if (novo_campo?.nome === undefined || novo_campo?.nome === '') {
      set_campo_obrigatorio_nome_campo(true)

    } else {

      if (error_validacao_max === false && error_validacao_min === false && error_valor_padrao === false) {
        // novo_campo
        // set_novo_campo((old: any) => ({
        //   ...old,
        //   ['obrigatorio']: flag_campo_obrigatorio,
        //   ['validacao.validacao_max']: validacao_max,
        //   ['validacao.validacao_min']: validacao_min,
        // }));
        let campo_final: CampoSchema = {
          ...novo_campo,
          nome: novo_campo?.nome ?? '',
          opcoes: novo_campo?.opcoes !== undefined ? novo_campo?.opcoes.toString().split(',') : [],
          tipo: (novo_campo?.tipo ?? TipoArmazem_array[3]) as TipoCampo,
          obrigatorio: flag_campo_obrigatorio,
          validacao: {
            ...(novo_campo?.validacao ?? {}),   // mantém os outros campos dentro de validacao
            max: validacao_max === undefined ? undefined : Number(validacao_max),
            min: validacao_min === undefined ? undefined : Number(validacao_min),
          },
        }
        delete (campo_final as any).validacao_max
        delete (campo_final as any).validacao_min

        set_novo_campo(campo_final);
        let aux_campos = novo_armazem?.schema_custom === undefined ? undefined : novo_armazem?.schema_custom.campos
        if (aux_campos !== undefined) {
          let lista_aux = [...aux_campos, campo_final]

          set_novo_armazem((prev: any) => ({
            ...prev,
            schema_custom: { campos: lista_aux }// [...(prev.schema_custom.campos ?? { campos: [] }), { campos: campo_final }]
          }));
        } else {
          set_novo_armazem((old: any) => ({
            ...old,
            'schema_custom': { campos: [campo_final] },
          }));
        }
        set_lista_de_campos((old: any) => [...old, campo_final]);

        set_flag_open_modal_add_campo(false)
        set_flag_campo_obrigatorio(false)
        set_error_validacao_max(false)
        set_error_validacao_min(false)
        set_error_valor_padrao(false)
        set_novo_campo(undefined)
        set_validacao_min('')
        set_validacao_max('')
        set_campo_obrigatorio_nome_campo(false)

      }
    }

  }
  const handle_add_entrada = async () => {
    if (nova_entrada?.data_entrada === undefined || nova_entrada?.data_entrada === '') {
      set_error_data_entrada(true)

    } else if (nova_entrada?.quantidade_entrada === undefined) {
      set_error_quantidade_entrada(true)

    } else if (nova_entrada?.registado_por === undefined || nova_entrada?.registado_por === '') {
      set_error_entrada_registado_por(true)

    } else {

      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, 'armazens/' + armazem_selecionado?.id_armazem + '/entradas', {
          id_armazem: armazem_selecionado?.id_armazem,
          data_entrada: nova_entrada?.data_entrada === undefined ? '' : new Date(nova_entrada?.data_entrada).toISOString(),
          quantidade_entrada: nova_entrada?.quantidade_entrada === undefined ? '' : Number(nova_entrada?.quantidade_entrada),
          unidade: nova_entrada?.unidade === undefined ? '' : nova_entrada?.unidade,
          documento_ref: nova_entrada?.documento_ref === undefined ? '' : nova_entrada?.documento_ref,
          observacoes: nova_entrada?.observacoes === undefined ? '' : nova_entrada?.observacoes,
          registado_por: nova_entrada?.registado_por === undefined ? '' : nova_entrada?.registado_por,
          dados: Object.assign({}, ...nova_entrada?.dados),
          create_date: new Date().toISOString(),
          last_update: new Date().toISOString(),
          uuid: '',

        });
        if (lista_de_entradas.length === 0) {
          set_lista_de_entradas([res.data])
          if (lista_de_saidas_e_entradas.length === 0) {
            set_lista_de_saidas_e_entradas([res.data])
          } else {
            set_lista_de_saidas_e_entradas((old: any) => [...old, res.data])
          }
        } else {
          set_lista_de_entradas((old: any) => [...old, res.data])
          set_lista_de_saidas_e_entradas((old: any) => [...old, res.data])
        }
        setMessage(operacao_sucesso)
        setOpenSnackSuccess(true);
        setIsLoading(false);
        func_reset_entrada()

      } catch (error) {
        func_print("handle_add_entrada", error, true);
        setIsLoading(false);

        if ((error as any)?.response?.data?.mensagem && !((error as any)?.response?.data?.erros)) {

          setMessage((error as any).response.data.mensagem);;
        } else if ((error as any)?.response?.data?.mensagem && (error as any)?.response?.data?.erros) {

          const frase = (error as any).response.data.erros.join(', ');
          setMessage((error as any).response.data.mensagem + ': ' + frase);;

        } else {
          setMessage(operacao_erro);
        }
        setOpenSnackError(true);

      }
    }

  }
  const handle_edit_entrada = async () => {
    if (nova_entrada?.data_entrada === undefined || nova_entrada?.data_entrada === '') {
      set_error_data_entrada(true)

    } else if (nova_entrada?.quantidade_entrada === undefined) {
      set_error_quantidade_entrada(true)

    } else if (nova_entrada?.registado_por === undefined || nova_entrada?.registado_por === '') {
      set_error_entrada_registado_por(true)

    } else {

      try {
        setIsLoading(true);

        let res = await put(auth.token.cookie_token, 'armazens/' + armazem_selecionado?.id_armazem + '/entradas/' + nova_entrada.id_entrada, {
          id_armazem: armazem_selecionado?.id_armazem,
          data_entrada: nova_entrada?.data_entrada === undefined ? '' : new Date(nova_entrada?.data_entrada).toISOString(),
          quantidade_entrada: nova_entrada?.quantidade_entrada === undefined ? '' : Number(nova_entrada?.quantidade_entrada),
          unidade: nova_entrada?.unidade === undefined ? '' : nova_entrada?.unidade,
          documento_ref: nova_entrada?.documento_ref === undefined ? '' : nova_entrada?.documento_ref,
          observacoes: nova_entrada?.observacoes === undefined ? '' : nova_entrada?.observacoes,
          registado_por: nova_entrada?.registado_por === undefined ? '' : nova_entrada?.registado_por,
          dados: Object.assign({}, ...nova_entrada?.dados),
          create_date: new Date().toISOString(),
          last_update: new Date().toISOString(),
          uuid: '',

        });

        let aux_lista_de_entradas = lista_de_entradas.map((el) => {
          if (el.id_entrada === res.data.id_entrada) {
            return res.data
          } else {
            return el
          }
        })
        let aux_lista_de_saidas_e_entradas = lista_de_saidas_e_entradas.map((el) => {
          if ('id_entrada' in el && el.id_entrada === res.data.id_entrada) {
            return res.data
          } else {
            return el
          }
        })


        set_lista_de_entradas(aux_lista_de_entradas)
        set_lista_de_saidas_e_entradas(aux_lista_de_saidas_e_entradas)

        setMessage(operacao_sucesso)
        setOpenSnackSuccess(true);
        setIsLoading(false);
        func_reset_entrada()

      } catch (error) {
        func_print("handle_edit_entrada", error, true);
        setIsLoading(false);

        if ((error as any)?.response?.data?.mensagem && !((error as any)?.response?.data?.erros)) {

          setMessage((error as any).response.data.mensagem);;
        } else if ((error as any)?.response?.data?.mensagem && (error as any)?.response?.data?.erros) {

          const frase = (error as any).response.data.erros.join(', ');
          setMessage((error as any).response.data.mensagem + ': ' + frase);;

        } else {
          setMessage(operacao_erro);
        }
        setOpenSnackError(true);
      }
    }

  }
  const handle_add_saida = async () => {
    if (nova_saida?.data_saida === undefined || nova_saida?.data_saida === '') {
      set_error_data_saida(true)
    } else if (nova_saida?.quantidade_saida === undefined) {
      set_error_quantidade_saida(true)

    } else if (nova_saida?.registado_por === undefined || nova_saida?.registado_por === '') {
      set_error_saida_registado_por(true)

    } else if (nova_saida?.motivo === undefined || nova_saida?.motivo === '') {
      set_error_motivo(true)

    } else {

      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, 'armazens/' + armazem_selecionado?.id_armazem + '/saidas', {
          id_armazem: armazem_selecionado?.id_armazem,
          data_saida: nova_saida?.data_saida === undefined ? '' : new Date(nova_saida?.data_saida).toISOString(),
          quantidade_saida: nova_saida?.quantidade_saida === undefined ? '' : nova_saida?.quantidade_saida,
          unidade: nova_saida?.unidade === undefined ? '' : nova_saida?.unidade,
          documento_ref: nova_saida?.documento_ref === undefined ? '' : nova_saida?.documento_ref,
          observacoes: nova_saida?.observacoes === undefined ? '' : nova_saida?.observacoes,
          registado_por: nova_saida?.registado_por === undefined ? '' : nova_saida?.registado_por,
          motivo: nova_saida?.motivo === undefined ? '' : nova_saida?.motivo,
          destino: nova_saida?.destino === undefined ? '' : nova_saida?.destino,
          dados: Object.assign({}, ...nova_saida?.dados),
          create_date: new Date().toISOString(),
          last_update: new Date().toISOString(),
          uuid: '',

        });
        if (lista_de_saidas.length === 0) {
          set_lista_de_saidas([res.data])
          if (lista_de_saidas_e_entradas.length === 0) {
            set_lista_de_saidas_e_entradas([res.data])
          } else {
            set_lista_de_saidas_e_entradas((old: any) => [...old, res.data])
          }
        } else {
          set_lista_de_saidas((old: any) => [...old, res.data])
          set_lista_de_saidas_e_entradas((old: any) => [...old, res.data])

        }

        setMessage(operacao_sucesso)
        setOpenSnackSuccess(true);
        setIsLoading(false);
        func_reset_saida()

      } catch (error) {
        func_print("handle_add_saida", error, true);
        setIsLoading(false);

        if ((error as any)?.response?.data?.mensagem && !((error as any)?.response?.data?.erros)) {

          setMessage((error as any).response.data.mensagem);;
        } else if ((error as any)?.response?.data?.mensagem && (error as any)?.response?.data?.erros) {

          const frase = (error as any).response.data.erros.join(', ');
          setMessage((error as any).response.data.mensagem + ': ' + frase);;

        } else {
          setMessage(operacao_erro);
        }
        setOpenSnackError(true);
      }
    }

  }
  const handle_edit_saida = async () => {
    if (nova_saida?.data_saida === undefined || nova_saida?.data_saida === '') {
      set_error_data_saida(true)
    } else if (nova_saida?.quantidade_saida === undefined) {
      set_error_quantidade_saida(true)

    } else if (nova_saida?.registado_por === undefined || nova_saida?.registado_por === '') {
      set_error_saida_registado_por(true)

    } else if (nova_saida?.motivo === undefined || nova_saida?.motivo === '') {
      set_error_motivo(true)

    } else {

      try {
        setIsLoading(true);
        let res = await put(auth.token.cookie_token, 'armazens/' + armazem_selecionado?.id_armazem + '/saidas/' + nova_saida.id_saida, {
          id_armazem: armazem_selecionado?.id_armazem,
          data_saida: nova_saida?.data_saida === undefined ? '' : new Date(nova_saida?.data_saida).toISOString(),
          quantidade_saida: nova_saida?.quantidade_saida === undefined ? '' : nova_saida?.quantidade_saida,
          unidade: nova_saida?.unidade === undefined ? '' : nova_saida?.unidade,
          documento_ref: nova_saida?.documento_ref === undefined ? '' : nova_saida?.documento_ref,
          observacoes: nova_saida?.observacoes === undefined ? '' : nova_saida?.observacoes,
          registado_por: nova_saida?.registado_por === undefined ? '' : nova_saida?.registado_por,
          motivo: nova_saida?.motivo === undefined ? '' : nova_saida?.motivo,
          destino: nova_saida?.destino === undefined ? '' : nova_saida?.destino,
          dados: Object.assign({}, ...nova_saida?.dados),
          create_date: new Date().toISOString(),
          last_update: new Date().toISOString(),
          uuid: '',

        });


        let aux_lista_de_saidas = lista_de_saidas.map((el) => {
          if (el.id_saida === res.data.id_saida) {
            return res.data
          } else {
            return el
          }
        })
        let aux_lista_de_saidas_e_entradas = lista_de_saidas_e_entradas.map((el) => {
          if ('id_saida' in el && el.id_saida === res.data.id_saida) {
            return res.data
          } else {
            return el
          }
        })


        set_lista_de_saidas(aux_lista_de_saidas)
        set_lista_de_saidas_e_entradas(aux_lista_de_saidas_e_entradas)


        setMessage(operacao_sucesso)
        setOpenSnackSuccess(true);
        setIsLoading(false);
        func_reset_saida()

      } catch (error) {
        func_print("criar_armazem", error, true);
        setIsLoading(false);

        if ((error as any)?.response?.data?.mensagem && !((error as any)?.response?.data?.erros)) {

          setMessage((error as any).response.data.mensagem);;
        } else if ((error as any)?.response?.data?.mensagem && (error as any)?.response?.data?.erros) {

          const frase = (error as any).response.data.erros.join(', ');
          setMessage((error as any).response.data.mensagem + ': ' + frase);;

        } else {
          setMessage(operacao_erro);
        }
        setOpenSnackError(true);
      }
    }

  }
  const handle_delete_entrada_saida = async () => {
    try {
      setIsLoading(true);

      if (entrada_ou_saida_to_delete && 'id_saida' in entrada_ou_saida_to_delete && entrada_ou_saida_to_delete.id_saida !== undefined) {
        let res = await del(auth.token.cookie_token,
          `armazens/${armazem_selecionado?.id_armazem}/saidas/${entrada_ou_saida_to_delete?.id_saida}`
        );
        if (res.status === 204) {
          let lista_aux: any = lista_de_saidas_e_entradas?.filter((el) => {
            if (el && 'id_saida' in el && el.id_saida !== undefined && el.id_saida === entrada_ou_saida_to_delete?.id_saida) {

            } else {
              return el
            }
          })
          set_lista_de_saidas_e_entradas(lista_aux === undefined ? [] : lista_aux)
          set_entrada_ou_saida_to_delete(undefined)
          setMessage("Registo eliminado com sucesso!");
          set_open_dialog_tem_a_certeza_que_quer_eliminar_entrada_ou_saida(false);
          setOpenSnackSuccess(true);

        } else {
          setMessage("Erro ao eliminar o registo!");
          setOpenSnackError(true);
        }
      } else if (entrada_ou_saida_to_delete && 'id_entrada' in entrada_ou_saida_to_delete && entrada_ou_saida_to_delete.id_entrada !== undefined) {

        let res = await del(auth.token.cookie_token,
          `armazens/${armazem_selecionado?.id_armazem}/entradas/${entrada_ou_saida_to_delete?.id_entrada}`
        );
        if (res.status === 204) {
          let lista_aux: any = lista_de_saidas_e_entradas?.filter((el) => {
            if (el && 'id_entrada' in el && el.id_entrada !== undefined && el.id_entrada === entrada_ou_saida_to_delete?.id_entrada) {
            } else {
              return el

            }
          })
          set_lista_de_saidas_e_entradas(lista_aux === undefined ? [] : lista_aux)
          set_entrada_ou_saida_to_delete(undefined)
          setMessage("Registo eliminado com sucesso!");
          set_open_dialog_tem_a_certeza_que_quer_eliminar_entrada_ou_saida(false);
          setOpenSnackSuccess(true);

        } else {
          setMessage("Erro ao eliminar o registo!");
          setOpenSnackError(true);
        }
      }


      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_armazem", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  }
  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);


  const get_info_entradas_saidas = async (id_armazem: number) => {
    try {
      setIsLoading(true);
      let res_entradas = await get(auth.token.cookie_token, 'armazens/' + id_armazem + '/entradas');
      let res_saidas = await get(auth.token.cookie_token, 'armazens/' + id_armazem + '/saidas');

      set_lista_de_entradas(res_entradas.data)
      set_lista_de_saidas(res_saidas.data)
      let aux_lista_entradas_e_saidas_ordenada_por_data = [

        ...res_entradas.data,
        ...res_saidas.data
      ].sort((a, b) => new Date(a.data).getTime() - new Date(b.data).getTime())


      set_lista_de_saidas_e_entradas(aux_lista_entradas_e_saidas_ordenada_por_data)

      setIsLoading(false);

    } catch (error) {
      func_print("get_info", error, true);
      setIsLoading(false);
    }
  }


  const getValorCampo = (dados: Icampovariavel[] | undefined, nome: string) => {

    const obj = dados?.find((o) => o[nome] !== undefined);


    return obj?.[nome] ?? "";
  };

  const setValorCampo = (dados: Icampovariavel[] = [], nome: string, valor: string) => {
    const idx = dados.findIndex((o) => o[nome] !== undefined);
    const valor_final = valor !== '' && !isNaN(Number(valor)) ? Number(valor) : valor

    if (idx >= 0) {
      const novo = [...dados];
      novo[idx] = { ...novo[idx], [nome]: valor_final };
      return novo;
    }

    return [...dados, { [nome]: valor_final }];
  };

  const normalizarTexto = (texto: string) => {
    return texto
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]/g, "");
  };

  const getValorVazioPorTipo = (tipo: string) => {
    if (tipo === "number" || tipo === "integer") {
      return 0;
    }

    if (tipo === "boolean") {
      return false;
    }

    return "";
  };

  const criarDadosAPartirDoArtigo = (
    camposArmazem: any[],
    artigoFatura: any
  ) => {
    const dados: Record<string, any> = {};

    const camposDoArtigo = Object.keys(artigoFatura || {});

    camposArmazem.forEach((campoArmazem) => {
      const nomeCampoArmazem = campoArmazem.nome;
      const nomeCampoArmazemNormalizado = normalizarTexto(nomeCampoArmazem);

      const campoEncontradoNaFatura = camposDoArtigo.find((campoArtigo) => {
        return normalizarTexto(campoArtigo) === nomeCampoArmazemNormalizado;
      });

      let valor =
        campoEncontradoNaFatura !== undefined
          ? artigoFatura[campoEncontradoNaFatura]
          : getValorVazioPorTipo(campoArmazem.tipo);

      if (campoArmazem.tipo === "number" || campoArmazem.tipo === "integer") {
        valor =
          valor !== "" && valor !== null && valor !== undefined
            ? Number(valor)
            : 0;
      }

      if (campoArmazem.tipo === "boolean") {
        valor = Boolean(valor);
      }

      dados[nomeCampoArmazem] = valor;
    });
    const array_to_return = Object.entries(dados).map(([key, value]) => ({
      [key]: value,
    }));
    return array_to_return;
  };


  const uploadDocumento = async (selectedFile: File) => {
    if (!selectedFile) {
      setMessage("Nenhum ficheiro selecionado.");
      setOpenSnackError(true);
      return;
    }

    try {
      setIsLoading(true);

      const formData = new FormData();
      formData.append("file", selectedFile);

      const response = await post_file_faturas(
        auth.token.cookie_token,
        `/analisar`,
        formData
      );

      if (response.status === 200) {
        setMessage("Documento carregado com sucesso!");
        setOpenSnackSuccess(true);
        if (Array.isArray(response.data.fatura.artigos) && response.data.fatura.artigos.length > 0) {

          const aux_data = response.data.fatura.data
            ? new Date(response.data.fatura.data).toISOString().split("T")[0]
            : "";

          const aux_doc = response.data.fatura.numero_documento
            ? response.data.fatura.numero_documento
            : "";

          const camposArmazem = armazem_selecionado?.schema_custom?.campos || [];

          const aux_list_from_faturas: ArmazemEntrada[] =
            response.data.fatura.artigos.map((el: any) => {
              return {
                id_entrada: 0,
                id_armazem: armazem_selecionado?.id_armazem || 0,
                data_entrada: aux_data,

                dados: criarDadosAPartirDoArtigo(camposArmazem, el),

                quantidade_entrada: Number(el.quantidade) || 0,
                unidade: el.unidade_medida_quantidade || "",
                documento_ref: aux_doc || "",
                observacoes: "",
                registado_por: "",
                last_update: new Date().toISOString(),
                create_date: new Date().toISOString(),
                uuid: "",
              };
            });

          set_list_aux_from_faturas(aux_list_from_faturas);

          console.log("aux_list_from_faturas", aux_list_from_faturas);

          set_open_modal_confirmar_dados_da_fatura(true);

        } else {
          setMessage("Documento carregado, mas nenhum artigo foi encontrado.");
          setOpenSnackError(true);
        }
      } else {
        setMessage("Erro ao carregar documento.");
        setOpenSnackError(true);
      }
    } catch (error: any) {
      func_print("uploadDocumento", error, true);

      if (error?.response?.data?.message) {
        setMessage(error.response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }

      setOpenSnackError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CustomThemeProvider>
      <Snackbar
        open={openSnackSuccess}
        autoHideDuration={2000}
        onClose={() => setOpenSnackSuccess(false)}
      >
        <Alert
          onClose={() => setOpenSnackSuccess(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSnackError}
        autoHideDuration={2000}
        onClose={() => setOpenSnackError(false)}
      >
        <Alert
          onClose={() => setOpenSnackError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {message}

        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <HomeViewTecnico title=" Armazéns" />

        <main className={classes.contents}>
          <div className={classes.toolbars} />
          {isLoading ? (
            <LoadingVulpes />
          ) :

            <div className={`${classes.label} p-4`}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1
              }}>


                <div>
                  <button
                    type="button"
                    onClick={() => {
                      set_flag_open_modal_add_tabela(true);
                      set_novo_armazem((old: any) => ({ ...old, 'tipo_armazem': 'outros' }));
                    }}
                    className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                  >
                    <AddIcon sx={{ fontSize: 18 }} />
                    Adicionar Armazém
                  </button>
                </div>

                <div className="mt-5 w-[90%] flex flex-wrap justify-start self-start gap-4">
                  {
                    lista_de_armazens.length === 0 || lista_de_armazens === undefined ? (
                      <div className="text-gray-400">Armazéns Não Encontrados</div>
                    ) : (
                      lista_de_armazens.map((el, key) => {
                        const isSelected = armazem_selecionado?.id_armazem === el.id_armazem;
                        const isHovered = hover_armazes.flag && hover_armazes.id === el.id_armazem;
                        return (
                          <div
                            key={key}
                            className={`
                            flex flex-col items-center justify-center w-[150px] min-w-[150px] p-4 rounded-xl cursor-pointer
                            transition-all duration-200
                            ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                            ${isHovered ? 'shadow-md' : 'shadow-sm'}
                          `}
                            onMouseEnter={() => setHover_armazes({ flag: true, id: el.id_armazem })}
                            onMouseLeave={() => setHover_armazes({ flag: false, id: el.id_armazem })}
                            onClick={() => {
                              set_armazem_selecionado(el);
                              get_info_entradas_saidas(el.id_armazem);
                            }}
                          >
                            <div className="text-sm font-medium text-gray-800 text-center">
                              {el.nome}
                            </div>
                            <div
                              className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                            />
                          </div>
                        );
                      })
                    )
                  }
                </div>

                {
                  armazem_selecionado === undefined ? <></> :
                    <div>
                      <div className="flex flex-row items-center justify-end p-5 pb-2">
                        <ButtonCadernos
                          mostrarBotaoApagar
                          mostrarBotaoEditar
                          aoClicarApagar={() => {
                            set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                            set_armazem_to_delete(armazem_selecionado)
                          }}
                          aoClicarEditar={() => {
                            set_flag_open_modal_add_tabela(true)
                            set_flag_open_modal_edit_tabela(true)
                            set_novo_armazem(armazem_selecionado)
                            set_flag_alerta_stock_minimo(armazem_selecionado.validacao_config.alerta_stock_minimo)
                            set_flag_armazem_ativo(armazem_selecionado.activo)
                            set_flag_controlar_stock(armazem_selecionado.validacao_config.controlar_stock)
                            set_flag_permitir_stock_negativo(armazem_selecionado.validacao_config.permitir_stock_negativo)
                            set_stock_minimo_default(armazem_selecionado.validacao_config.stock_minimo_default.toString())
                          }}
                        />
                      </div>
                      <div className="flex flex-col gap-6 w-full p-5 rounded-xl bg-gray-50/80">
                        {/* row 1: Designacao, Tipo, Localizacao, Stock minimo */}
                        <div className="flex flex-wrap gap-6 w-full">
                          <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Designação</div>
                            <div className="text-base font-medium text-gray-800">{armazem_selecionado?.nome || '-'}</div>
                          </div>
                          <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Tipo</div>
                            <div className="text-base font-medium text-gray-800">{armazem_selecionado?.tipo_armazem || '-'}</div>
                          </div>
                          <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Localização</div>
                            <div className="text-base font-medium text-gray-800">{armazem_selecionado?.localizacao || '-'}</div>
                          </div>
                          <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Stock Mínimo</div>
                            <div className="text-base font-medium text-gray-800">{armazem_selecionado?.validacao_config.stock_minimo_default ?? '-'}</div>
                          </div>
                        </div>
                        {/* row 2: switches */}
                        <div className="flex flex-wrap gap-6 w-full">
                          <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Controlar Stock</div>
                            <Switch
                              height={22}
                              width={44}
                              onColor={cores.cor1}
                              offColor="#e5e7eb"
                              onChange={() => { }}
                              checked={armazem_selecionado?.validacao_config.controlar_stock}
                            />
                          </div>
                          <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Alerta de Stock Reduzido</div>
                            <Switch
                              height={22}
                              width={44}
                              onColor={cores.cor1}
                              offColor="#e5e7eb"
                              onChange={() => { }}
                              checked={armazem_selecionado?.validacao_config.permitir_stock_negativo}
                            />
                          </div>
                          <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Stock Negativo</div>
                            <Switch
                              height={22}
                              width={44}
                              onColor={cores.cor1}
                              offColor="#e5e7eb"
                              onChange={() => { }}
                              checked={armazem_selecionado?.validacao_config.alerta_stock_minimo}
                            />
                          </div>
                          <div className="flex-1 min-w-[180px] flex flex-col gap-3">
                            <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Armazém Ativo</div>
                            <Switch
                              height={22}
                              width={44}
                              onColor={cores.cor1}
                              offColor="#e5e7eb"
                              onChange={() => { }}
                              checked={armazem_selecionado?.activo}
                            />
                          </div>
                        </div>
                      </div>

                      {
                        armazem_selecionado.schema_custom.campos.length === 0 ? <></> :
                          <div className="flex flex-row items-center justify-end p-4 mt-8 w-full">
                            <div className="flex gap-2">
                              <Button
                                component="label"
                                role={undefined}
                                // variant="contained"
                                tabIndex={-1}
                                // startIcon={<FileUploadIcon />}
                                style={{
                                  backgroundColor: "transparent",
                                  color: cores.cor1,
                                  // maxHeight: 30,
                                  // width: 250,
                                  // marginRight: 10
                                  cursor: "pointer",
                                  // padding: "8px 12px",
                                  border: "1px solid #ccc",
                                  borderRadius: "6px",
                                  // display: "inline-block",
                                  // importante
                                  whiteSpace: "nowrap",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  minWidth: "fit-content",
                                  marginLeft: 5
                                }}
                              >
                                <FileUploadIcon />
                                Upload de Fatura

                                <input
                                  type="file"
                                  accept="application/pdf,image/*"
                                  hidden
                                  multiple={false}
                                  onChange={(event) => {
                                    const file = event.target.files?.[0];
                                    if (file) {
                                      uploadDocumento(file);
                                    }
                                  }}
                                />
                              </Button>
                              <button
                                type="button"
                                onClick={() => {
                                  set_flag_open_modal_add_entrada(true);
                                  if (armazem_selecionado?.schema_custom?.campos !== undefined) {
                                    const lista_aux = armazem_selecionado.schema_custom.campos.map((el) => ({ [el.nome]: '' }));
                                    set_nova_entrada((old: any) => ({ ...old, 'dados': lista_aux }));
                                  }
                                }}
                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-[#8b6914] bg-[#f2ca80]/40 hover:bg-[#f2ca80]/50 transition-colors border-0 outline-none cursor-pointer"
                              >
                                <LoginIcon sx={{ fontSize: 18 }} />
                                Entrada Produto
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  set_flag_open_modal_add_saida(true);
                                  if (armazem_selecionado?.schema_custom.campos !== undefined) {

                                    const lista_aux = armazem_selecionado.schema_custom.campos.map((el) => ({ [el.nome]: '' }));
                                    set_nova_saida((old: any) => ({ ...old, 'dados': lista_aux }));
                                  }
                                }}
                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-[#2563eb] bg-[#5d8ef7]/25 hover:bg-[#5d8ef7]/35 transition-colors border-0 outline-none cursor-pointer"
                              >
                                <LogoutIcon sx={{ fontSize: 18 }} />
                                Saída Produto
                              </button>
                            </div>
                          </div>
                      }

                      <div
                        className="flex flex-row justify-around bg-[#c94f1e] text-white pt-2.5 pb-2.5 px-2.5 rounded-t-xl font-semibold border-b border-[#c94f1e]/30"

                      >
                        {
                          armazem_selecionado.schema_custom.campos.length === 0 ? <div className="font-semibold text-gray-400">Colunas Não Encontradas</div> :
                            armazem_selecionado.schema_custom.campos.map((el, key) => {
                              return (
                                <div key={key} className="flex flex-1 justify-center min-w-0">
                                  {el.nome}
                                </div>
                              )
                            })
                        }

                        <div className="flex shrink-0 justify-center items-center px-4">
                          Ações
                        </div>

                      </div>






                    </div>
                }
                <div>

                  {
                    lista_de_saidas_e_entradas.length === 0 ? (
                      (armazem_selecionado?.schema_custom?.campos?.length ?? 0) > 0 ? (
                        <div className="flex flex-row justify-center items-center py-2.5 px-2.5 rounded-b-xl bg-gray-50 text-gray-500 text-sm">
                          Ainda não contém registos
                        </div>
                      ) : <></>
                    ) : (
                      lista_de_saidas_e_entradas.map((el, key) => {
                        const isSaida = 'id_saida' in el && el.id_saida !== undefined;
                        return (
                          <div
                            key={key}
                            className="group flex flex-row justify-around py-2.5 px-2.5 rounded-none relative overflow-visible"
                            style={{
                              backgroundColor: isSaida ? 'rgba(93, 142, 247, 0.12)' : 'rgba(242, 202, 128, 0.25)',
                            }}
                          >
                            <div
                              className="absolute left-0 top-2 bottom-2 w-1.5 opacity-0 group-hover:opacity-100 transition-opacity rounded-r"
                              style={{ backgroundColor: isSaida ? '#5d8ef7' : cores.cor4 }}
                            />

                            {Object.keys(el.dados).length > 0 &&
                              armazem_selecionado?.schema_custom.campos !== undefined &&
                              armazem_selecionado?.schema_custom.campos.length > 0 ? (
                              (() => {
                                const dados = el.dados as unknown as Record<string, unknown>;
                                const campos = armazem_selecionado.schema_custom.campos;

                                return (
                                  <>
                                    {campos.map((campo) => {
                                      const valor = dados[campo.nome];

                                      return (
                                        <div key={campo.nome} className="flex flex-1 justify-center items-center min-w-0">
                                          {valor === "" || valor == null ? "-" : String(valor)}
                                        </div>
                                      );
                                    })}
                                  </>
                                );
                              })()
                            ) : <></>}
                            <div className="flex shrink-0 justify-center items-center px-4">
                              <ButtonCadernos
                                mostrarBotaoApagar
                                mostrarBotaoEditar
                                aoClicarApagar={() => {
                                  set_open_dialog_tem_a_certeza_que_quer_eliminar_entrada_ou_saida(true)
                                  set_entrada_ou_saida_to_delete(el)
                                }}
                                aoClicarEditar={() => {

                                  if ('id_saida' in el && el.id_saida !== undefined) {
                                    set_flag_open_modal_add_saida(true)
                                    set_flag_open_modal_edit_saida(true)

                                    if (armazem_selecionado?.schema_custom?.campos !== undefined) {

                                      let lista_aux = armazem_selecionado.schema_custom.campos.map((ele) => {
                                        return { [ele.nome]: (el.dados as Record<string, any>)[ele.nome] }
                                      })


                                      if (lista_aux !== undefined) {
                                        set_nova_saida((old: any) => ({
                                          ...old,
                                          ...el,

                                          'data_saida': new Date(el.data_saida).toISOString().split('T')[0],
                                          'dados': lista_aux,
                                        }));

                                      }
                                    }

                                  } else if ('id_entrada' in el && el.id_entrada !== undefined) {

                                    set_flag_open_modal_add_entrada(true)
                                    set_flag_open_modal_edit_entrada(true)

                                    if (armazem_selecionado?.schema_custom?.campos !== undefined) {

                                      let lista_aux = armazem_selecionado.schema_custom.campos.map((ele) => {
                                        return { [ele.nome]: (el.dados as Record<string, any>)[ele.nome] }
                                      })

                                      if (lista_aux !== undefined) {
                                        set_nova_entrada((old: any) => ({
                                          ...old,
                                          ...el,
                                          'data_entrada': new Date(el.data_entrada).toISOString().split('T')[0],
                                          'dados': lista_aux,
                                        }));
                                      }
                                    }
                                  }

                                }}
                              />

                            </div>
                          </div>
                        );
                      })
                    )
                  }





                </div>
              </div>



            </div>
          }
        </main>
      </div>

      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={flag_open_modal_add_tabela}
      >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
          <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
            <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
              {flag_open_modal_edit_tabela === true ? 'Editar Armazém' : 'Criar Armazém'}
            </h2>
            <button
              type="button"
              onClick={() => {
                set_flag_open_modal_add_tabela(false);
                func_reset_all();
              }}
              className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </button>
          </div>
          {
            isLoading === true ?
              loader() :
              <>
                <div className="flex flex-col items-center w-full flex-1 overflow-auto">
                  <div className="flex items-center w-full py-4 px-4">
                    <Stepper activeStep={passo_atual} alternativeLabel className="w-full">
                      {steps.map((label) => (
                        <Step key={label} sx={{
                          '& .MuiStepLabel-root .Mui-completed': {
                            color: cores.cor3, // circle color (COMPLETED)
                          },
                          '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel':
                          {
                            color: cores.cor2, // Just text label (COMPLETED)
                          },
                          '& .MuiStepLabel-root .Mui-active': {
                            color: cores.cor1, // circle color (ACTIVE)
                          },
                          '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel':
                          {
                            color: cores.cor1, // Just text label (ACTIVE)
                          },
                          '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                            fill: 'white', // circle's number (ACTIVE)
                          },
                        }}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>

                  </div>

                  {
                    passo_atual === 0 ?
                      <div className="flex flex-col w-full p-6 ">
                        {/* row 1: Designação, Tipo, Localização */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                          <div className="w-full">
                            <CustomTextField
                              variant="outlined"
                              label='Designação'
                              name="nome"
                              value={novo_armazem?.nome === undefined ? '' : novo_armazem?.nome}
                              onChange={onInputChange}
                              error={campo_obrigatorio_nome}
                              helperText={campo_obrigatorio_nome ? 'Campo Obrigatório' : ""}
                              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                          </div>
                          <div className="w-full">
                            <CustomSelect
                              label='Tipo de Armazém'
                              name="tipo_armazem"
                              options={TipoArmazem_array}
                              fullWidth
                              value={novo_armazem?.tipo_armazem === undefined ? '' : novo_armazem?.tipo_armazem}
                              onChange={onInputChange}
                            />
                          </div>
                          <div className="w-full">
                            <CustomTextField
                              variant="outlined"
                              label='Localização'
                              name="localizacao"
                              value={novo_armazem?.localizacao === undefined ? '' : novo_armazem?.localizacao}
                              onChange={onInputChange}
                              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                          </div>
                        </div>
                        {/* row 2: Descrição (2 cols) + Stock mínimo (1 col) */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                          <div className="md:col-span-2 w-full">
                            <CustomTextField
                              variant="outlined"
                              label='Descrição'
                              name="descricao"
                              value={novo_armazem?.descricao === undefined ? '' : novo_armazem?.descricao}
                              onChange={onInputChange}
                              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                          </div>
                          <div className="w-full">
                            <CustomTextField
                              variant="outlined"
                              label="Stock Mínimo"
                              name="stock_minimo_default"
                              value={stock_minimo_default === undefined ? '' : stock_minimo_default}
                              onChange={onInputChange}
                              error={error_stock_minimo_default}
                              helperText={error_stock_minimo_default ? 'Apenas números são aceites' : ""}
                              sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                            />
                          </div>
                        </div>
                        {/* row 3: switches */}
                        <div className="flex flex-wrap gap-6 items-end justify-between w-full mt-4 px-8">
                          <div className="flex flex-col items-center gap-2">
                            <span className="text-sm text-gray-600">Controlar Stock</span>
                            <Switch
                              height={22}
                              width={44}
                              onColor={cores.cor1}
                              offColor="#e5e7eb"
                              onChange={() => set_flag_controlar_stock(!flag_controlar_stock)}
                              checked={flag_controlar_stock}
                            />
                          </div>
                          <div className="flex flex-col items-center gap-2">
                            <span className="text-sm text-gray-600">Stock Negativo</span>
                            <Switch
                              height={22}
                              width={44}
                              onColor={cores.cor1}
                              offColor="#e5e7eb"
                              onChange={() => set_flag_permitir_stock_negativo(!flag_permitir_stock_negativo)}
                              checked={flag_permitir_stock_negativo}
                            />
                          </div>
                          <div className="flex flex-col items-center gap-2">
                            <span className="text-sm text-gray-600 text-center">Alerta de Stock Reduzido</span>
                            <Switch
                              height={22}
                              width={44}
                              onColor={cores.cor1}
                              offColor="#e5e7eb"
                              onChange={() => set_flag_alerta_stock_minimo(!flag_alerta_stock_minimo)}
                              checked={flag_alerta_stock_minimo}
                            />
                          </div>
                          <div className="flex flex-col items-center gap-2">
                            <span className="text-sm text-gray-600">Armazém Ativo</span>
                            <Switch
                              height={22}
                              width={44}
                              onColor={cores.cor1}
                              offColor="#e5e7eb"
                              onChange={() => set_flag_armazem_ativo(!flag_armazem_ativo)}
                              checked={flag_armazem_ativo}
                            />
                          </div>
                        </div>

                        <div className="flex justify-end w-full pt-4">
                          <button
                            type="button"
                            onClick={() => {
                              if (novo_armazem?.nome === undefined || novo_armazem.nome === '') {
                                set_campo_obrigatorio_nome(true);
                              } else if (error_stock_minimo_default === false) {
                                set_passo_atual(1);
                                set_campo_obrigatorio_nome(false);
                              }
                            }}
                            className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                          >
                            Seguinte
                          </button>
                        </div>
                      </div>
                      :
                      <div className="flex flex-col w-full p-6 gap-6">
                        <div className="flex items-end justify-between w-full">
                          <div className="text-sm font-semibold text-gray-500 uppercase tracking-wider">
                            Selecionar Campos Existentes
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              set_flag_open_modal_add_campo(true);
                              set_novo_campo((old: any) => ({ ...old, 'tipo': 'string' }));
                            }}
                            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                          >
                            <AddIcon sx={{ fontSize: 18 }} />
                            Adicionar um Novo Campo
                          </button>
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 w-full">
                          {
                            lista_de_campos.length === 0 ? (
                              <div className="text-gray-400 py-4">Campos Não Encontrados</div>
                            ) : (
                              lista_de_campos.filter(
                                (item, index, self) =>
                                  index === self.findIndex(el => el.nome === item.nome)
                              ).map((el, key) => {
                                const isSelected = novo_armazem?.schema_custom?.campos?.find((elem: any) => elem.nome === el.nome) !== undefined;
                                const isHovered = hover.flag && hover.nome === el.nome;
                                return (
                                  <div
                                    key={key}
                                    className={`
                                      flex flex-col items-center justify-center min-w-0 p-4 rounded-xl cursor-pointer
                                      transition-all duration-200
                                      ${isSelected ? 'ring-2 ring-[#c94f1e] bg-[#f2d1c2]/30' : 'bg-gray-50/80'}
                                      ${isHovered ? 'shadow-md' : 'shadow-sm'}
                                    `}
                                    onMouseEnter={() => setHover({ flag: true, nome: el.nome })}
                                    onMouseLeave={() => setHover({ flag: false, nome: el.nome })}
                                    onClick={() => {
                                      let aux_obj = novo_armazem?.schema_custom === undefined || novo_armazem?.schema_custom.campos === undefined ? undefined : novo_armazem?.schema_custom.campos.find((elem: any) => {
                                        if (elem.nome === el.nome) {
                                          return el
                                        }
                                      })

                                      if (aux_obj === undefined) {

                                        if (novo_armazem?.schema_custom === undefined || novo_armazem?.schema_custom.campos === undefined || novo_armazem?.schema_custom.campos.length === 0) {
                                          set_novo_armazem((prev: any) => ({
                                            ...prev,
                                            schema_custom: { campos: [el] }
                                          }));

                                        } else {
                                          let lista_aux = novo_armazem?.schema_custom.campos.concat([el])
                                          set_novo_armazem((prev: any) => ({
                                            ...prev,
                                            schema_custom: { campos: lista_aux }
                                          }));
                                        }


                                      } else {
                                        set_novo_armazem((prev: any) => ({
                                          ...prev,
                                          schema_custom: {
                                            campos: (prev.schema_custom.campos ?? []).filter(
                                              (eleme: any) => {
                                                if (eleme.nome !== el.nome) {
                                                  return eleme
                                                }
                                              }
                                            ),
                                          }
                                        }));
                                      }

                                    }}
                                  >
                                    <div className="text-sm font-medium text-gray-800 text-center">
                                      {el.nome}
                                    </div>
                                    <div
                                      className={`mt-2 w-full h-1 rounded-full ${isSelected ? 'bg-[#c94f1e]' : 'bg-gray-200'}`}
                                    />
                                  </div>
                                );
                              })
                            )
                          }
                        </div>

                        <div className="flex justify-between w-full pt-4">
                          <button
                            type="button"
                            onClick={() => set_passo_atual(0)}
                            className="px-5 py-2.5 rounded-xl font-medium text-sm text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors border-0 outline-none cursor-pointer"
                          >
                            Voltar
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              if (flag_open_modal_edit_tabela) {
                                edit_armazem();
                              } else {
                                criar_armazem();
                              }
                            }}
                            className="px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                          >
                            {flag_open_modal_edit_tabela ? 'Salvar' : 'Criar'}
                          </button>
                        </div>
                      </div>
                  }



                </div>




              </>
          }

        </div>
      </Modal>
      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={flag_open_modal_add_campo}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          backgroundColor: 'white',
          width: '80%',
          height: '90%',
          flexDirection: 'column',
          borderRadius: 5,
        }}>
          <div style={{
            width: '100%',
            display: "flex",
            alignItems: 'flex-start',
            justifyContent: 'flex-end',
            flex: 0.1,
          }}>
            <Button
              sx={{ color: "#AAAAAA" }}
              size="large"
              onClick={() => {
                set_flag_open_modal_add_campo(false)
                func_reset_campos()
              }}
            >
              <CloseIcon />
            </Button>
          </div>
          {
            isLoading === true ?
              loader() :
              <>
                <div
                  style={{
                    backgroundColor: cores.cor1,
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: 0.1,
                    fontWeight: 'bold',
                    color: 'white',
                    fontSize: 25,
                    width: '100%',
                    fontFamily: "candara"
                  }}>

                  Criar Campo

                </div>
                <div style={{
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: "center",
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  // backgroundColor:'red'
                }}>



                  <div style={{
                    width: '100%',
                    flex: 0.8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignSelf: 'center',
                    // backgroundColor:'red',
                    alignItems: "center"

                  }}>
                    <div style={{
                      display: 'flex',
                      flex: 0.2,
                      flexDirection: 'row',
                      width: '90%',
                      justifySelf: 'center'
                    }}>

                      <div style={{
                        display: 'flex',
                        flex: 0.33,
                      }}>
                        <CustomTextField
                          label='Designação'
                          name="nome"
                          value={novo_campo?.nome === undefined ? '' : novo_campo?.nome}
                          onChange={onInputChange_campo}
                          error={campo_obrigatorio_nome_campo}
                          helperText={campo_obrigatorio_nome_campo ? 'Campo de Preenchimento Obrigatório' : ""}
                        />
                      </div>
                      <div style={{
                        display: 'flex',
                        flex: 0.33,
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <div style={{
                          display: "flex",
                          flex: 0.25,
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'row',


                        }}>
                          <div style={{
                            marginRight: 10
                          }}>

                            Tipo
                          </div>

                          <Select
                            value={novo_campo?.tipo === undefined ? '' : novo_campo?.tipo}
                            label={''}
                            name={'tipo'}
                            sx={{
                              fontSize: 14,
                              fontFamily: "verdana",
                              minWidth: 200,
                            }}
                            onChange={onInputChange_campo}
                          >

                            {TIPOS_CAMPO.map((item: any, key) => {

                              return (
                                <MenuItem key={key} value={item.value}>
                                  <Typography
                                    style={{
                                      fontSize: 14,
                                      fontFamily: "candara",
                                    }}
                                  >
                                    {item.label}
                                  </Typography>
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </div>

                        {/* <CustomSelect
                          label='Tipo do campo '
                          name="tipo"
                          options={TipoArmazem_array}
                          minWidth={200}
                          value={novo_armazem?.tipo_armazem === undefined ? '' : novo_armazem?.tipo_armazem}
                          onChange={onInputChange}
                        /> */}
                      </div>
                      <div style={{
                        display: 'flex',
                        flex: 0.33,
                      }}>

                        <CustomTextField
                          label='Label'
                          name="label"
                          value={novo_campo?.label === undefined ? '' : novo_campo?.label}
                          onChange={onInputChange_campo}
                        />
                      </div>
                    </div>
                    <div style={{
                      display: 'flex',
                      flex: 0.2,

                      flexDirection: 'row',
                      width: '90%',
                      justifySelf: 'center'
                    }}>
                      <CustomTextField
                        label='Descricao'
                        name="descricao"
                        value={novo_campo?.descricao === undefined ? '' : novo_campo?.descricao}
                        onChange={onInputChange_campo}
                      />
                    </div>
                    {
                      novo_campo?.tipo !== 'select' ? <></> :

                        <div style={{
                          display: 'flex',
                          flex: 0.2,

                          flexDirection: 'row',
                          width: '90%',
                          justifySelf: 'center'
                        }}>
                          <CustomTextField
                            label='Caso seja selecionável, adicionar aqui as opções de escolha, separadas por vírgulas.'
                            name="opcoes"
                            value={novo_campo?.opcoes === undefined ? '' : novo_campo?.opcoes}
                            onChange={onInputChange_campo}
                          />
                        </div>
                    }

                    <div style={{
                      display: 'flex',
                      flex: 0.2,

                      flexDirection: 'row',
                      width: '90%',
                      justifySelf: 'center'
                    }}>
                      {
                        novo_campo?.tipo !== 'number' && novo_campo?.tipo !== 'integer' ? <></> :
                          <>
                            <div style={{
                              display: 'flex',
                              flex: 0.25,
                              paddingRight: 5,
                            }}>
                              <CustomTextField
                                label="Valor Máximo"
                                name="validacao_max"
                                value={validacao_max === undefined ? '' : validacao_max}
                                onChange={onInputChange_campo}
                                error={error_validacao_max}
                                helperText={error_validacao_max ? 'Apenas números são aceites' : ""}
                              />
                            </div>
                            <div style={{
                              display: 'flex',
                              flex: 0.25,
                              paddingRight: 5,
                              paddingLeft: 5,

                            }}>
                              <CustomTextField
                                label="Valor Minimo"
                                name="validacao_min"
                                value={validacao_min === undefined ? '' : validacao_min}
                                onChange={onInputChange_campo}
                                error={error_validacao_min}
                                helperText={error_validacao_min ? 'Apenas números são aceites' : ""}
                              />
                            </div>
                            <div style={{
                              display: 'flex',
                              flex: 0.25,
                              paddingRight: 5,
                              paddingLeft: 5,

                            }}>
                              <CustomTextField
                                label="Valor Padrão"
                                name="valor_padrao"
                                value={novo_campo?.valor_padrao === undefined ? '' : novo_campo?.valor_padrao}
                                onChange={onInputChange_campo}
                                error={error_valor_padrao}
                                helperText={error_valor_padrao ? 'Apenas números são aceites' : ""}
                              />
                            </div>
                          </>
                      }

                      <div style={{
                        display: 'flex',
                        flex: 0.25,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        // backgroundColor:'red',
                        alignSelf: 'center'
                      }}>
                        <div style={{ marginRight: 5 }}>
                          Obrigatório
                        </div>

                        <Switch
                          height={20}
                          width={35}
                          onColor={cores.cor1}
                          offColor={cores.cor3}
                          onChange={() => {
                            set_flag_campo_obrigatorio(!flag_campo_obrigatorio)
                          }}
                          checked={flag_campo_obrigatorio} />
                      </div>




                    </div>

                  </div>


                  <div style={{
                    display: 'flex',
                    width: '90%',
                    flexDirection: 'row',
                    justifyContent: "flex-end",
                    justifySelf: 'center',
                    // flex: 0.1,
                    // backgroundColor:'red'

                  }}>
                    <Button
                      style={{
                        backgroundColor: cores.cor1,
                        color: 'white'
                      }}
                      onClick={() => { handle_add_campo() }}
                    >
                      Adicionar Campo

                    </Button>
                  </div>

                </div>




              </>
          }

        </div>
      </Modal>
      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={flag_open_modal_add_entrada}
      >
        <div className="flex flex-col bg-white w-[70%] max-h-[85%] rounded-xl overflow-hidden">
          <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
            <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
              {flag_open_modal_edit_entrada ? 'Editar Entrada Produto' : 'Criar Entrada Produto'}
            </h2>
            <button
              type="button"
              onClick={() => {
                set_flag_open_modal_add_entrada(false);
                func_reset_entrada();
              }}
              className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </button>
          </div>
          {
            isLoading === true ?
              loader() :
              <div className="flex flex-col w-full flex-1 overflow-auto p-6">
                {/* row 1 */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                  <div className="w-full">
                    <TextField
                      variant="outlined"
                      label="Data de Entrada do Produto"
                      name="data_entrada"
                      type="date"
                      error={error_data_entrada}
                      helperText={error_data_entrada ? 'Data obrigatória' : ''}
                      value={nova_entrada?.data_entrada === undefined ? '' : nova_entrada?.data_entrada}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        set_nova_entrada((old: any) => ({
                          ...old,
                          'data_entrada': event.target.value,
                        }));
                      }}
                      fullWidth
                      margin="normal"
                      InputLabelProps={{ shrink: true }}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Quantidade"
                      name="quantidade_entrada"
                      value={nova_entrada?.quantidade_entrada === undefined ? '' : nova_entrada?.quantidade_entrada}
                      onChange={onInputChange_entrada}
                      error={error_quantidade_entrada}
                      helperText={error_quantidade_entrada ? 'Campo Obrigatório' : ''}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Unidade"
                      name="unidade"
                      value={nova_entrada?.unidade === undefined ? '' : nova_entrada?.unidade}
                      onChange={onInputChange_entrada}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                </div>
                {/* row 2 */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Referencia do Documento"
                      name="documento_ref"
                      value={nova_entrada?.documento_ref === undefined ? '' : nova_entrada?.documento_ref}
                      onChange={onInputChange_entrada}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Observações"
                      name="observacoes"
                      value={nova_entrada?.observacoes === undefined ? '' : nova_entrada?.observacoes}
                      onChange={onInputChange_entrada}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Autor do Registo"
                      name="registado_por"
                      value={nova_entrada?.registado_por === undefined ? '' : nova_entrada?.registado_por}
                      error={error_entrada_registado_por}
                      helperText={error_entrada_registado_por ? 'Campo Obrigatório' : ''}
                      onChange={onInputChange_entrada}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                </div>
                {/* row 3: custom fields */}
                {
                  armazem_selecionado?.schema_custom?.campos?.length === 0 || armazem_selecionado?.schema_custom?.campos === undefined ? null : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full items-start">
                      {
                        armazem_selecionado?.schema_custom.campos.map((el, key) => (
                          <div key={key} className="w-full">
                            {el.tipo === 'select' ? (
                              <CustomSelect
                                value={String(getValorCampo(nova_entrada?.dados, el.nome))}
                                onChange={(event: any) => {
                                  set_nova_entrada((old: any) => ({
                                    ...old,
                                    dados: setValorCampo(old.dados, el.nome, event.target.value),
                                  }));
                                }}
                                options={el.opcoes === undefined || el.opcoes?.length === 0 ? [] : el.opcoes}
                                label={el.nome}
                                name={el.nome}
                              />
                            ) : el.tipo === 'boolean' ? (
                              <div className="flex flex-col gap-2">
                                <span className="text-sm text-gray-600">{el.nome}</span>
                                <Switch
                                  height={22}
                                  width={44}
                                  onColor={cores.cor1}
                                  offColor="#e5e7eb"
                                  onChange={(event: any) => {
                                    set_nova_entrada((old: any) => ({
                                      ...old,
                                      dados: setValorCampo(old.dados, el.nome, event),
                                    }));
                                  }}
                                  checked={getValorCampo(nova_entrada?.dados, el.nome) === undefined ? false : Boolean(getValorCampo(nova_entrada?.dados, el.nome))}
                                />
                              </div>
                            ) : (
                              <CustomTextField
                                variant="outlined"
                                label={el.nome}
                                type={el.tipo === 'integer' || el.tipo === 'number' ? 'number' : el.tipo}
                                value={getValorCampo(nova_entrada?.dados, el.nome)}
                                onChange={(event: any) => {
                                  set_nova_entrada((old: any) => ({
                                    ...old,
                                    dados: setValorCampo(old.dados, el.nome, event.target.value),
                                  }));
                                }}
                                error={(el.tipo !== 'number' && el.tipo !== 'integer') && el.obrigatorio && String(getValorCampo(nova_entrada?.dados, el.nome)).length === 0 ? true :
                                  (el.tipo === 'number' || el.tipo === 'integer') && String(getValorCampo(nova_entrada?.dados, el.nome)).length === 0 ? true :
                                    (el.tipo === 'number' || el.tipo === 'integer') && isNaN(Number(getValorCampo(nova_entrada?.dados, el.nome))) ? true : false}
                                helperText={(el.tipo !== 'number' && el.tipo !== 'integer') && el.obrigatorio && String(getValorCampo(nova_entrada?.dados, el.nome)).length === 0 ? 'Campo Obrigatório' :
                                  (el.tipo === 'number' || el.tipo === 'integer') && String(getValorCampo(nova_entrada?.dados, el.nome)).length === 0 ? 'Campo Obrigatório' :
                                    (el.tipo === 'number' || el.tipo === 'integer') && isNaN(Number(getValorCampo(nova_entrada?.dados, el.nome))) ? 'Insira apenas números' : ''}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                              />
                            )}
                          </div>
                        ))
                      }
                    </div>
                  )}
                <div className="flex justify-end w-full pt-6">
                  <button
                    type="button"
                    onClick={() => { flag_open_modal_edit_entrada ? handle_edit_entrada() : handle_add_entrada() }}
                    className="px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                  >
                    {flag_open_modal_edit_entrada ? 'Editar Entrada Produto' : 'Adicionar Entrada Produto'}
                  </button>
                </div>
              </div>
          }
        </div>
      </Modal>
      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={flag_open_modal_add_saida}
      >
        <div className="flex flex-col bg-white w-[70%] max-h-[85%] rounded-xl overflow-hidden">
          <div className="flex items-center justify-between w-full p-4 border-b border-gray-100">
            <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
              {flag_open_modal_edit_saida ? 'Editar Saída Produto' : 'Criar Saída Produto'}
            </h2>
            <button
              type="button"
              onClick={() => {
                set_flag_open_modal_add_saida(false);
                func_reset_saida();
              }}
              className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
            >
              <CloseIcon sx={{ fontSize: 24 }} />
            </button>
          </div>
          {
            isLoading === true ?
              loader() :
              <div className="flex flex-col w-full flex-1 overflow-auto p-6">
                {/* row 1 */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                  <div className="w-full">
                    <TextField
                      variant="outlined"
                      label="Data de Saída do Produto"
                      name="data_saida"
                      type="date"
                      error={error_data_saida}
                      helperText={error_data_saida ? 'Data obrigatória' : ''}
                      value={nova_saida?.data_saida === undefined ? '' : nova_saida?.data_saida}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        set_nova_saida((old: any) => ({
                          ...old,
                          'data_saida': event.target.value,
                        }));
                      }}
                      fullWidth
                      margin="normal"
                      InputLabelProps={{ shrink: true }}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Quantidade"
                      name="quantidade_saida"
                      value={nova_saida?.quantidade_saida === undefined ? '' : nova_saida?.quantidade_saida}
                      onChange={onInputChange_saida}
                      error={error_quantidade_saida}
                      helperText={error_quantidade_saida ? 'Campo Obrigatório' : ''}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Unidade"
                      name="unidade"
                      value={nova_saida?.unidade === undefined ? '' : nova_saida?.unidade}
                      onChange={onInputChange_saida}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                </div>
                {/* row 2 */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Referencia do Documento"
                      name="documento_ref"
                      value={nova_saida?.documento_ref === undefined ? '' : nova_saida?.documento_ref}
                      onChange={onInputChange_saida}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Observações"
                      name="observacoes"
                      value={nova_saida?.observacoes === undefined ? '' : nova_saida?.observacoes}
                      onChange={onInputChange_saida}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Autor do Registo"
                      name="registado_por"
                      value={nova_saida?.registado_por === undefined ? '' : nova_saida?.registado_por}
                      error={error_saida_registado_por}
                      helperText={error_saida_registado_por ? 'Campo Obrigatório' : ''}
                      onChange={onInputChange_saida}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                </div>
                {/* row 3 */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full items-start">
                  <div className="w-full">
                    <CustomSelect
                      label="Motivo"
                      name="motivo"
                      // style={error_motivo ? { borderColor: 'red' } : {}}
                      // helperText={error_motivo ? 'Campo Obrigatório' : ''}
                      value={nova_saida?.motivo === undefined ? '' : nova_saida?.motivo}
                      onChange={onInputChange_saida}
                      options={TIPOS_MOTIVO as any}
                      flag_list_map_obj={true}
                      fullWidth
                    />
                    {error_motivo && (
                      <span className="text-red-500 text-xs mt-1 block">
                        Campo obrigatório
                      </span>
                    )}
                  </div>
                  <div className="w-full">
                    <CustomTextField
                      variant="outlined"
                      label="Destino"
                      name="destino"
                      value={nova_saida?.destino === undefined ? '' : nova_saida?.destino}
                      onChange={onInputChange_saida}
                      sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                  </div>
                </div>
                {/* row 4: custom fields */}
                {
                  armazem_selecionado?.schema_custom?.campos?.length === 0 || armazem_selecionado?.schema_custom?.campos === undefined ? null : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full items-start">
                      {
                        armazem_selecionado?.schema_custom.campos.map((el, key) => (
                          <div key={key} className="w-full">
                            {el.tipo === 'select' ? (
                              <CustomSelect
                                value={String(getValorCampo(nova_saida?.dados, el.nome))}
                                onChange={(event: any) => {
                                  set_nova_saida((old: any) => ({
                                    ...old,
                                    dados: setValorCampo(old.dados, el.nome, event.target.value),
                                  }));
                                }}
                                options={el.opcoes === undefined || el.opcoes?.length === 0 ? [] : el.opcoes}
                                label={el.nome}
                                name={el.nome}
                              />
                            ) : el.tipo === 'boolean' ? (
                              <div className="flex flex-col gap-2">
                                <span className="text-sm text-gray-600">{el.nome}</span>
                                <Switch
                                  height={22}
                                  width={44}
                                  onColor={cores.cor1}
                                  offColor="#e5e7eb"
                                  onChange={(event: any) => {
                                    set_nova_saida((old: any) => ({
                                      ...old,
                                      dados: setValorCampo(old.dados, el.nome, event),
                                    }));
                                  }}
                                  checked={getValorCampo(nova_saida?.dados, el.nome) === undefined ? false : Boolean(getValorCampo(nova_saida?.dados, el.nome))}
                                />
                              </div>
                            ) : (
                              <CustomTextField
                                variant="outlined"
                                label={el.nome}
                                type={el.tipo === 'integer' || el.tipo === 'number' ? 'number' : el.tipo}
                                value={getValorCampo(nova_saida?.dados, el.nome)}
                                onChange={(event: any) => {
                                  set_nova_saida((old: any) => ({
                                    ...old,
                                    dados: setValorCampo(old.dados, el.nome, event.target.value),
                                  }));
                                }}
                                error={(el.tipo !== 'number' && el.tipo !== 'integer') && el.obrigatorio && String(getValorCampo(nova_saida?.dados, el.nome)).length === 0 ? true :
                                  (el.tipo === 'number' || el.tipo === 'integer') && String(getValorCampo(nova_saida?.dados, el.nome)).length === 0 ? true :
                                    (el.tipo === 'number' || el.tipo === 'integer') && isNaN(Number(getValorCampo(nova_saida?.dados, el.nome))) ? true : false}
                                helperText={(el.tipo !== 'number' && el.tipo !== 'integer') && el.obrigatorio && String(getValorCampo(nova_saida?.dados, el.nome)).length === 0 ? 'Campo Obrigatório' :
                                  (el.tipo === 'number' || el.tipo === 'integer') && String(getValorCampo(nova_saida?.dados, el.nome)).length === 0 ? 'Campo Obrigatório' :
                                    (el.tipo === 'number' || el.tipo === 'integer') && isNaN(Number(getValorCampo(nova_saida?.dados, el.nome))) ? 'Insira apenas números' : ''}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                              />
                            )}
                          </div>
                        ))
                      }
                    </div>
                  )}
                <div className="flex justify-end w-full pt-6">
                  <button
                    type="button"
                    onClick={() => { flag_open_modal_edit_saida ? handle_edit_saida() : handle_add_saida() }}
                    className="px-5 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                  >
                    {flag_open_modal_edit_saida ? 'Editar Saída Produto' : 'Adicionar Saída Produto'}
                  </button>
                </div>
              </div>
          }
        </div>
      </Modal>

      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
        onConfirm={handle_delete_armazem}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar_entrada_ou_saida}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar_entrada_ou_saida(false)}
        onConfirm={handle_delete_entrada_saida}
        message="Deseja eliminar o registo?"
      />
      {
        open_modal_confirmar_dados_da_fatura === false ? <></> :
          <ModalValidarDadosFatura
            lista_artigos={list_aux_from_faturas === undefined ? [] : list_aux_from_faturas}
            flag_open_modal={open_modal_confirmar_dados_da_fatura}
            set_flag_open_modal={set_open_modal_confirmar_dados_da_fatura}
            setMessage={setMessage}
            setOpenSnackError={setOpenSnackError}
            setOpenSnackSuccess={setOpenSnackSuccess}
            set_lista_artigos={set_list_aux_from_faturas}
            lista_de_entradas={lista_de_entradas}
            set_lista_de_entradas={set_lista_de_entradas}
            lista_de_saidas_e_entradas={lista_de_saidas_e_entradas}
            set_lista_de_saidas_e_entradas={set_lista_de_saidas_e_entradas}
            armazem_selecionado={armazem_selecionado}

          ></ModalValidarDadosFatura>

      }


    </CustomThemeProvider>
  )



}

export default Armazem;
